import {Component, Input, OnInit} from '@angular/core';
import {Brodernamn} from './models/brodernamn';
import {AktiviteterService} from './aktiviteter.service';
import {Consmin} from './models/consmin';

@Component({
    selector: 'app-consminlista-import',
    templateUrl: './consminlista-import.component.html',
    styles: ['table.small tr td {font-size: small; vertical-align: middle}']
})
export class ConsminlistaImportComponent implements OnInit {
    lista: Consmin[] = [];
    broderlista: Brodernamn[];
    raw: string;
    processing = false;

    @Input()
    set counter(c: number) {
        console.log(c);
    }

    constructor(private aktiviteterService: AktiviteterService) {
    }

    process(event: Event) {
        console.log('Processing.');
        const textarea = event.target as HTMLTextAreaElement;
        if (textarea.value !== '') {
            this.split(textarea.value);
        }
    }

    split(s: string): void {
        console.log('Split börjar');
        const lista: Consmin[] = [];
        for (const row of s.split('\n')) {
            if (row.length > 0) {
                const col = row.split('\t');
                if (col.length === 7) {
                    lista.push({
                        fnamn: col[0],
                        enamn: col[1],
                        nation: col[2],
                        office: col[3],
                        tidpunkt: col[4],
                        skrivet_av: col[5],
                        motivering: col[6],
                        broder_id: null,
                    } as Consmin);
                }
            }
        }
        this.lista = lista;
        console.log('Split slutar');
    }

    ngOnInit(): void {
        if (!this.broderlista) {
            this.aktiviteterService.getBroderlista().then(result => {
                this.broderlista = result;
            });
        }
    }

    save(): void {
        for (const item of this.lista) {
            delete item.suggestions;
        }
        this.aktiviteterService.saveConsmin(this.lista);
        this.raw = '';
        this.lista = [];
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/consminlista-import.component.ts